var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHandle = function SvgHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.707 1.706A1 1 0 0 0 14.294.293l-14.001 14a1 1 0 1 0 1.413 1.414l14.001-14Zm0 7.335a1 1 0 1 0-1.413-1.413l-6.666 6.666a1 1 0 0 0 1.413 1.413l6.666-6.666Z",
    clipRule: "evenodd"
  })));
};
export default SvgHandle;